<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref, useTemplateRef } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { AudioManagerService } from '~/services/audioManager.service';

interface Props {
  url: string;
}

const { url } = defineProps<Props>();
const audioRef = useTemplateRef('audio');
const audioManagerService = useService(AudioManagerService);

const playing = ref(false);

function toggleAudio() {
  audioManagerService.toggle(audioRef.value as HTMLAudioElement);
}

function handlePlayAudio() {
  playing.value = true;
}

function handleCloseAudio() {
  playing.value = false;
}

onMounted(() => {
  audioRef.value?.addEventListener('play', handlePlayAudio);
  audioRef.value?.addEventListener('pause', handleCloseAudio);
  audioRef.value?.addEventListener('ended', handleCloseAudio);
});

onBeforeUnmount(() => {
  audioRef.value?.removeEventListener('play', handlePlayAudio);
  audioRef.value?.removeEventListener('pause', handleCloseAudio);
  audioRef.value?.removeEventListener('ended', handleCloseAudio);
});

defineExpose({ toggleAudio });
</script>

<template>
  <div
    class="audio-radar-container h-7 w-7"
    :class="{ 'animate-container': playing }"
  >
    <img
      class="radar-image h-7 w-7"
      src="~/assets/image/im/icon-audio-radar-1.svg"
      alt="radar1"
    />
    <img
      class="radar-image h-7 w-7"
      src="~/assets/image/im/icon-audio-radar-2.svg"
      alt="radar2"
    />
    <img
      class="radar-image static-image h-7 w-7"
      src="~/assets/image/im/icon-audio-radar.svg"
      alt="radar"
    />
    <audio ref="audio" :src="url" preload="auto"></audio>
  </div>
</template>

<style scoped>
.audio-radar-container {
  position: relative;
}

.radar-image {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.static-image {
  opacity: 1;
}

.animate-container .static-image {
  opacity: 0;
}

.animate-container .radar-image:nth-child(1) {
  animation: 1.2s radar-animation 0s linear infinite;
}

.animate-container .radar-image:nth-child(2) {
  animation: 1.2s radar-animation 0.4s linear infinite;
}

.animate-container .radar-image:nth-child(3) {
  animation: 1.2s radar-animation 0.8s linear infinite;
}
</style>
